import h from 'virtual-dom/h';
import diff from 'virtual-dom/diff';
import patch from 'virtual-dom/patch';
import createElement from 'virtual-dom/create-element';

export interface StarRatingOptions {
    starsElementId: string;
    starInactiveClass?: string;
    starActiveClass?: string;
    starClass?: string;
    totalAmountOfStars: number;
    selectedAmountOfStars: number;
}

export class StarRating {
    public options: StarRatingOptions;
    public rootVirtualElement: VirtualDOM.VNode; // The virtual root element of the star rating
    public rootDomElement: Element; // The actual root dom element of the star rating

    constructor(options: StarRatingOptions) {
        this.options = options;

        this.options.starActiveClass = this.options.starActiveClass || 'icon icon-normal icon-star';
        this.options.starInactiveClass = this.options.starInactiveClass || 'icon icon-normal icon-star disabled';
        this.options.starClass = this.options.starClass || 'star-colored clickable';

        this.createRootElements();
        this.render();
    }

    protected element(elementId: string) {
        let element = document.getElementById(elementId);
        if (element) {
            return element;
        }

        throw new Error(`No element with id ${elementId} could be found`);
    }

    protected createRootElements(): void {
        const baseElement = this.element(this.options.starsElementId);
        this.rootVirtualElement = this.createVirtualRootElement(['']);
        this.rootDomElement = createElement(this.rootVirtualElement);
        baseElement.appendChild(this.rootDomElement);
    }

    /**
     * Creates a root virtual element which holds the rendered items
     * Return the default wrapper element
     */
    protected createVirtualRootElement(elements: (string | VirtualDOM.VNode)[]): VirtualDOM.VNode {
        return this.wrapperElement(elements);
    }

    /**
     * Default wrapper element generator
     * Generates a div element
     */
    protected wrapperElement(elements: (string | VirtualDOM.VNode)[]): VirtualDOM.VNode {
        return h('div', {}, elements);
    }

    public setRating(rating: number) {
        this.options.selectedAmountOfStars = rating;
        this.render();
    }

    public getStarRating(): number {
        return this.options.selectedAmountOfStars;
    }

    protected render(): void {
        const elements = this.renderStars();
        const newRootElement = this.wrapperElement(elements);
        const patches = diff(this.rootVirtualElement, newRootElement);
        this.rootDomElement = patch(this.rootDomElement, patches);

        this.rootVirtualElement = newRootElement;
    }

    protected renderStars(): VirtualDOM.VNode[] {
        const stars: VirtualDOM.VNode[] = [...Array(this.options.totalAmountOfStars)]
            .map((_: any, i: number) =>
                h('i', {
                    className: `${this.options.starClass} ` + (i < this.options.selectedAmountOfStars
                        ? this.options.starActiveClass
                        : this.options.starInactiveClass),
                    onclick: () => {
                        this.setRating(i + 1);
                    }
                }, [])
        );

        return stars;
    }
}
